module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading && !_vm.profiles.length),
      expression: "loading && !profiles.length"
    }],
    attrs: {
      "element-loading-text": "Loading Profiles..."
    }
  }, [_c('div', {
    staticClass: "infinite-list-wrapper",
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "infinite-scroll-disabled": "disabled"
    }
  }, [_c('el-row', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticStyle: {
      "height": "600px",
      "overflow": "auto"
    },
    attrs: {
      "gutter": 6
    }
  }, _vm._l((_vm.profiles), function(profile) {
    return _c('el-col', {
      key: profile.id,
      attrs: {
        "span": 6
      }
    }, [_c('grid-card', {
      staticStyle: {
        "margin": "12px 0px"
      },
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showProfile(profile)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [(_vm.loading && _vm.profiles.length) ? _c('p', {
    staticClass: "load-more"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" Loading Profiles...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('p', [_vm._v("All Profiles Loaded")]) : _vm._e()])], 1), _vm._v(" "), (_vm.profile) ? _c('dialog-card', {
    attrs: {
      "initialProfile": _vm.profile,
      "visible": _vm.showProfileCard
    },
    on: {
      "close": _vm.handleCloseCard
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea38418a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/ProfilesBrowser.vue
// module id = 3417
// module chunks = 3